import {Component, HostListener, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {KeycloakService} from 'keycloak-angular';
import {GetPromptService} from '../../services/get-prompts/get-prompts.service';
import {AvaliacoesPromptService} from '../../services/avaliacoes-prompt/avaliacoes-prompt.service';
import {AuthService} from '../../services/auth.service';
import {DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {CadastroPromptService} from '../../services/cadastro-prompt/cadastro-prompt.service';
import {PerfilPromptService} from '../../services/bff-prompts-perfil/prompts-perfil.service';
import {combineLatest, firstValueFrom, Observable, of} from 'rxjs'; // Adicionado forkJoin
import {catchError, filter, map, switchMap, tap} from 'rxjs/operators'; // Adicionado switchMap, tap
import { MessageNotificationService } from '../../services/message-notification.service';
import { VALIDATION_MESSAGES, SUCCESS_MESSAGES, ERROR_MESSAGES } from '../../constants/validation-messages';
import { handleHttpError } from '../../utils/error-handler.util';
import { PromptDto } from '../../models/prompt-dto.model';
import { UserData } from '../../models/user-data.model';

import { AnalyticsService } from '../../services/analytics/analytics.service';

@Component({
  selector: 'app-tela-prompt',
  templateUrl: './tela-prompt.component.html',
  styleUrls: ['./tela-prompt.component.css'],
  standalone: false,
})
export class TelaPromptComponent implements OnInit {
  prompt: PromptDto | null = null;
  avaliacoes: any[] = [];
  avaliacoesFiltradas: any[] = [];
  mediaAvaliacao: number = 0;
  totalAvaliacoes: number = 0;
  modalVisivel: boolean = false;
  novaAvaliacao = { valor: 0, comentario: '' };
  legenda: string | null = null;
  isMobile: boolean = false;
  selectedText: string = '';
  campoComando: string = '';
  getPromptId: number = 0;
  userData: UserData | null = null;

  promptAditionalData: any;

  displayNomeAutor$: Observable<string> = of('Carregando...');
  displayAvatarAutor$: Observable<string> = of('../../../assets/imagem/avatar3.jpg');
  isLoadingPrompt: boolean = true;

  getLegend(starCount: number): string {
    switch (starCount) {
      case 1:
        return ' O prompt não resolveu meu problema. Não usarei novamente.';
      case 2:
        return 'O prompt ajudou pouco. Tive muito trabalho e não usarei novamente.';
      case 3:
        return 'O prompt resolveu parcialmente o meu problema. Precisou de ajustes consideráveis';
      case 4:
        return 'O prompt resolveu quase tudo pra mim. Fiz apenas pequenos ajustes. Recomendo.';
      case 5:
        return 'O prompt foi perfeito. Não precisei alterar nada. Super recomendado.';
      default:
        return '';
    }
  }

  atualizarLegenda(event: { value: number }): void {
    const legendas = [
      'O prompt não resolveu meu problema. Não usarei novamente.',
      'O prompt ajudou pouco. Tive muito trabalho e não usarei novamente.',
      'O prompt resolveu parcialmente o meu problema. Precisou de ajustes consideráveis',
      'O prompt resolveu quase tudo pra mim. Fiz apenas pequenos ajustes. Recomendo.',
      'O prompt foi perfeito. Não precisei alterar nada. Super recomendado.',
    ];
    this.legenda = legendas[event.value - 1] || null;
  }

  opcoesFiltro = [
    { label: 'Mais recente', value: 'maisRecente' },
    { label: 'Mais antigo', value: 'maisAntigo' },
    { label: 'Estrelas (5-1)', value: 'estrelasDesc' },
    { label: 'Estrelas (1-5)', value: 'estrelasAsc' },
  ];
  filtroSelecionado: string = '';

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private keycloakService: KeycloakService,
    private getPromptsService: GetPromptService,
    private router: Router,
    private avaliacoesPromptService: AvaliacoesPromptService,
    private sanitizer: DomSanitizer,
    private cadastroPromptService: CadastroPromptService,
    private perfilService: PerfilPromptService,
    private messageNotificationService: MessageNotificationService,
    private analyticsService: AnalyticsService,
  ) { }

  get sanitizedContent(): SafeHtml | null {
    if (this.prompt?.prompt_comando) {
      return this.sanitizer.bypassSecurityTrustHtml(this.prompt.prompt_comando);
    }
    return null;
  }
  autorDoPrompt: any = null;

  ngOnInit() {
  this.checkScreenSize();


  combineLatest([
    this.activatedRoute.paramMap,
    this.authService.userData$
  ]).pipe(
    switchMap(([params, userData]) => {
      const promptId = Number(params.get('id'));
      this.userData = userData;

      if (promptId) {
        this.getPromptId = promptId;
        this.isLoadingPrompt = true;
        this.displayNomeAutor$ = of('Carregando...');
        this.displayAvatarAutor$ = of('../../../assets/imagem/avatar3.jpg');

        return this.carregarDadosCompletosDoPrompt(promptId);
      } else {
        console.error("ID do prompt não encontrado na rota.");
        return of({ nome: 'Erro', avatarUrl: '../../../assets/imagem/avatar3.jpg' });
      }
    })
  ).subscribe({
    next: (dadosDeExibicao) => {
      this.displayNomeAutor$ = of(dadosDeExibicao.nome);
      this.displayAvatarAutor$ = of(dadosDeExibicao.avatarUrl);
      this.isLoadingPrompt = false;
    },
    error: (err) => {
      console.error("Erro fatal no fluxo de inicialização:", err);
      this.displayNomeAutor$ = of('Erro ao carregar');
      this.displayAvatarAutor$ = of('../../../assets/imagem/avatar3.jpg');
      this.isLoadingPrompt = false;
    }
  });
}

private carregarDadosCompletosDoPrompt(promptId: number): Observable<{ nome: string; avatarUrl: string }> {
  this.getAvaliacoesByPrompt(promptId);

  return this.getPromptsService.getPromptById(promptId).pipe(
    switchMap(resposta => {
      if (resposta?.data?.length) {
        this.prompt = resposta.data[0];
        this.analyticsService.evento('visualizar_prompt', {
          prompt_id: this.prompt.prompt_id,
          categoria:
            this.prompt.prompt_categoria && this.prompt.prompt_categoria.length > 0
              ? this.prompt.prompt_categoria[0].categoria_descricao
              : 'desconhecida',
        });
        return this.obterDadosDeExibicaoDoAutor();
      } else {
        throw new Error('Prompt não encontrado na API.');
      }
    }),
    catchError(err => {
      console.error("Erro ao carregar dados do prompt:", err);
      return of({ nome: 'Erro ao carregar prompt', avatarUrl: '../../../assets/imagem/avatar3.jpg' });
    })
  );
}

private obterDadosDeExibicaoDoAutor(): Observable<{ nome: string; avatarUrl: string }> {
    const avatarPadrao = '../../../assets/imagem/avatar3.jpg';

    if (!this.prompt || !this.prompt.usuario) {
        return of({ nome: 'Autor Desconhecido', avatarUrl: avatarPadrao });
    }

    const criadorDoPrompt = this.prompt.usuario;
    const loginUsuarioLogado = this.userData?.usuario_login;
    const loginDoAutor = criadorDoPrompt.usuario_login;
    const promptEhAnonimo = this.prompt.prompt_anonimo;

    const ehDono = loginUsuarioLogado && loginUsuarioLogado === loginDoAutor;

    if (ehDono && this.userData) {
        const nome = `${this.userData.usuario_apelido || loginDoAutor}`;
        const avatarBase64 = this.userData.usuario_base64_arqfoto;
        const avatarUrl = avatarBase64 ? `data:image/png;base64,${avatarBase64}` : avatarPadrao;
        return of({ nome, avatarUrl });

    } else if (promptEhAnonimo) {
        return of({ nome: 'Anônimo', avatarUrl: avatarPadrao });

    } else {
        return this.perfilService.getUserData(loginDoAutor).pipe(
            map(perfil => {
                const nome = (perfil ? perfil.usuario_apelido : criadorDoPrompt.usuario_nome) || loginDoAutor;
                const base64 = perfil ? perfil.usuario_base64_arqfoto : null;
                const avatarUrl = base64 ? `data:image/png;base64,${base64}` : avatarPadrao;
                return { nome, avatarUrl };
            }),
            catchError(() => {
                console.warn(`Falha ao buscar perfil para ${loginDoAutor}, usando dados de fallback.`);
                const nome = criadorDoPrompt.usuario_nome || loginDoAutor;
                return of({ nome, avatarUrl: avatarPadrao });
            })
        );
    }
}


  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    this.checkScreenSize();
  }

  checkScreenSize() {
    this.isMobile = window.innerWidth <= 768;
  }

  getAvaliacoesByPrompt(promptId: number) {
    this.avaliacoesPromptService.getAvaliacoesPorPrompt(promptId).subscribe({
      next: (res: any) => {
        this.avaliacoes = res.data || [];
        this.avaliacoesFiltradas = [...this.avaliacoes];
        this.totalAvaliacoes = this.avaliacoes.length;

        if (this.totalAvaliacoes > 0) {
          const somaAvaliacoes = this.avaliacoes.reduce(
            (sum: number, av: any) => sum + av.avaliacao_valor,
            0
          );
          this.mediaAvaliacao = Math.round(
            somaAvaliacoes / this.totalAvaliacoes
          );
        } else {
          this.mediaAvaliacao = 0;
        }
      },
      error: (err) => {
        console.error('Erro ao carregar avaliações:', err);
        const errorMessage = handleHttpError(err);
        this.messageNotificationService.showError(
          'Não foi possível carregar as avaliações. ' + errorMessage
        );
      },
    });
  }

  filtrarAvaliacoes() {
    switch (this.filtroSelecionado) {
      case 'maisRecente':
        this.avaliacoesFiltradas.sort(
          (a, b) =>
            new Date(b.dtcriacao).getTime() - new Date(a.dtcriacao).getTime()
        );
        break;
      case 'maisAntigo':
        this.avaliacoesFiltradas.sort(
          (a, b) =>
            new Date(a.dtcriacao).getTime() - new Date(b.dtcriacao).getTime()
        );
        break;
      case 'estrelasDesc':
        this.avaliacoesFiltradas.sort(
          (a, b) => b.avaliacao_valor - a.avaliacao_valor
        );
        break;
      case 'estrelasAsc':
        this.avaliacoesFiltradas.sort(
          (a, b) => a.avaliacao_valor - b.avaliacao_valor
        );
        break;
      default:
        this.avaliacoesFiltradas = [...this.avaliacoes];
        break;
    }
  }

  getUserAvatar(usuario: any): string {
    if (usuario && usuario.usuario_base64_arqfoto) {
      return `data:image/png;base64,${usuario.usuario_base64_arqfoto}`;
    }
    return '../../../assets/imagem/avatar3.jpg';
  }

  getPromptUserAvatar(arquivoAvatarBase64: string | null | undefined, promptIsMarkedAnonymous: boolean | null | undefined): string {
    if (promptIsMarkedAnonymous && (this.userData?.usuario_id !== this.prompt?.usuario?.usuario_id)) {
      return '../../../assets/imagem/avatar3.jpg'; // Avatar anônimo
    }

    if (arquivoAvatarBase64) {
      return `data:image/png;base64,${arquivoAvatarBase64}`;
    }
    return '../../../assets/imagem/avatar1.jpg'; // Avatar padrão
  }


  abrirModalAvaliacao() {
    if (this.authService.isAuthenticated()) {
      this.modalVisivel = true;
    } else {
      this.keycloakService.login();
    }
  }

  fecharModalAvaliacao() {
    this.modalVisivel = false;
    this.novaAvaliacao = { valor: 0, comentario: '' };
  }

  enviarAvaliacao() {
    if (this.novaAvaliacao.valor > 0) {
      const usuarioAutenticado = this.authService.getUserData();
      if (!usuarioAutenticado) {
        this.messageNotificationService.showError(
          VALIDATION_MESSAGES.LOGIN_REQUIRED
        );
        this.keycloakService.login();
        return;
      }

      if (!this.prompt) return;
      const idPrompt = this.prompt.prompt_id;
      const idUsuario = Number(usuarioAutenticado.usuario_id);
      const nota = this.novaAvaliacao.valor;
      const comentario = this.novaAvaliacao.comentario.trim();

      this.avaliacoesPromptService
        .adicionarAvaliacao(idPrompt, idUsuario, nota, comentario)
        .subscribe({
          next: (res) => {
            this.messageNotificationService.showSuccess(
              SUCCESS_MESSAGES.EVALUATION_SENT
            );
            this.fecharModalAvaliacao();
            this.getAvaliacoesByPrompt(idPrompt);
          },
          error: (err) => {
            console.error('Erro ao enviar avaliação:', err);
            const errorMessage = handleHttpError(err);
            this.messageNotificationService.showError(
              ERROR_MESSAGES.EVALUATION_FAILED + ' ' + errorMessage
            );
          },
        });
    } else {
      this.messageNotificationService.showError(
        VALIDATION_MESSAGES.SELECT_RATING
      );
    }
  }

  copiarPrompt() {
    if (this.prompt?.prompt_comando) {
      navigator.clipboard.writeText(this.prompt.prompt_comando).then(() => {
        this.messageNotificationService.showSuccess(
          SUCCESS_MESSAGES.COMMAND_COPIED
        );
        this.copiarPromptRegistrar();
      }, (err) => {
        console.error('Erro ao copiar texto:', err);
        this.messageNotificationService.showError(
          ERROR_MESSAGES.COPY_FAILED
        );
      });
    }
  }

  duplicarPrompt(prompt: any): void {
    if (!prompt || !prompt.prompt_id) {
      console.error('Erro: Prompt inválido.');
      return;
    }
    localStorage.setItem('duplicatedPromptId', String(prompt.prompt_id));
    this.router.navigate(['/cadastro-prompt']);
  }

  detectorCtrlC() {
    document.addEventListener('keydown', (event: KeyboardEvent) => {
      if (((event.ctrlKey || event.metaKey) && event.key === 'c') && (this.campoComando === 'Prompt')) {
        this.campoComando = '';
        this.copiarPromptRegistrar(); // Renomeado
      }
    });
  }


  copiarPromptRegistrar() {
    if (!this.getPromptId) return;
    this.cadastroPromptService.contadorExecucaoPrompt(this.getPromptId).subscribe({
      next: (res: any) => { /* console.log('Contador de cópia incrementado'); */ },
      error: (err) => {
        console.error('Erro ao registrar cópia do prompt:', err);
      },
    });
  }

  onCopy(event: ClipboardEvent) {
    this.onSelectionChange();
    if (this.selectedText && (this.campoComando === 'Prompt')) {
      event.clipboardData?.setData('text/plain', this.selectedText);
      event.preventDefault();
      this.copiarPromptRegistrar();
      this.campoComando = '';
    } else {

    }
  }

  campoSelecionado(comando: string) {
    this.campoComando = comando;
  }

  onBlur() {
  }

  onSelectionChange() {
    this.selectedText = window.getSelection()?.toString() || '';
  }

  voltar() {
    window.history.back();
  }
}
